import { Mail } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

// Define icon at module level to avoid creating JSX inside hook callbacks
const mailIcon = <Mail className="size-4" />;

export function createEmailsFilterConfig(): FilterStringConfig {
  return {
    label: 'Emails',
    icon: mailIcon,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: 'Search emails'
    }
  };
}
